import _ from 'lodash';

import {
  CLEAR_ENTITY_BY_ID,
  CLEAR_OFFLINE_SEARCH_RESULTS,
  CLEAR_UNSYNCHRONIZED_ENTITY,
  DOWNLOAD_ENTITY_FAILURE,
  DOWNLOAD_ENTITY_SUCCESS,
  SET_OFFLINE_DATA_ENTITIES,
  SET_UNSYNCHRONIZED_ENTITY_ID,
  START_DOWNLOAD_ENTITY,
  UPDATE_OFFLINE_SEARCH_RESULTS,
} from '../actions/OfflineDataActions';
import { ADD_OFFLINE_ATTACHMENT_SUCCESS } from '../form-designer/actions/file-upload.offline.actions';

const initialState = {
  entities: [],
  downloadingStates: [],
  unsynchronizedEntityId: undefined,
  offlineSearchResults: {},
};

export const offlineDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_OFFLINE_DATA_ENTITIES:
      return { ...state, entities: action.payload };
    case START_DOWNLOAD_ENTITY: {
      const { id } = action.payload;
      const states = _.union(state.downloadingStates, [id]);
      return { ...state, downloadingStates: states };
    }
    case DOWNLOAD_ENTITY_FAILURE: {
      const { id } = action.payload;
      const states = _.difference(state.downloadingStates, [id]);
      return { ...state, downloadingStates: states };
    }
    case DOWNLOAD_ENTITY_SUCCESS: {
      const { id, entity } = action.payload;
      const { downloadingStates, entities } = state;
      const states = _.difference(downloadingStates, [id]);
      const existingEntityIndex = _.findIndex(entities, (entity) => entity.id === id);
      const newEntities = [...entities];

      if (existingEntityIndex === -1) {
        newEntities.push({ id, entity, requestChanges: undefined });
      } else {
        newEntities[existingEntityIndex] = {
          ...newEntities[existingEntityIndex],
          entity,
          requestChanges: undefined,
        };
      }

      return { ...state, entities: newEntities, downloadingStates: states };
    }
    case SET_UNSYNCHRONIZED_ENTITY_ID: {
      const { id } = action.payload;
      return {
        ...state,
        unsynchronizedEntityId: id,
      };
    }
    case CLEAR_UNSYNCHRONIZED_ENTITY: {
      return {
        ...state,
        unsynchronizedEntityId: undefined,
      };
    }
    case CLEAR_ENTITY_BY_ID: {
      const { id } = action.payload;
      const { entities } = state;
      _.remove(entities, (entity) => entity.id === id);

      return {
        ...state,
        entities: [...entities],
      };
    }
    case UPDATE_OFFLINE_SEARCH_RESULTS: {
      const { searchResult } = action.payload;

      return {
        ...state,
        offlineSearchResults: {
          ...state.offlineSearchResults,
          ...searchResult,
        },
      };
    }
    case CLEAR_OFFLINE_SEARCH_RESULTS: {
      return {
        ...state,
        offlineSearchResults: {},
      };
    }

    case ADD_OFFLINE_ATTACHMENT_SUCCESS: {
      const { id, attachmentData } = action.payload;
      const { entities } = state;
      const existingEntityIndex = _.findIndex(entities, (entity) => entity.id === id);

      if (existingEntityIndex === -1) {
        return {
          ...state,
          entities: [...entities, { id, files: [attachmentData] }],
        };
      }

      const files = _.get(entities, `[${existingEntityIndex}].files`, []);

      entities[existingEntityIndex] = {
        ...entities[existingEntityIndex],
        files: files.concat([attachmentData]),
      };

      return {
        ...state,
        entities,
      };
    }

    default:
      return state;
  }
};

export default offlineDataReducer;
